import { createFileRoute, redirect } from '@tanstack/react-router';

import { ROUTES } from '@/config/routes';
import { isPlatformAdmin } from '@/host/access';
import { OrganizationsView } from '@/platform/orgs/OrganizationsView';

export const Route = createFileRoute('/_app/organizations')({
   beforeLoad: ({ context }) => {
      if (!isPlatformAdmin(context.user)) throw redirect({ to: ROUTES.HOME, replace: true });
   },
   component: OrganizationsView
});
